import {Validators} from "@angular/forms";
import {ProductCompositionsFormField} from "../types/product-compositions-modal.types";

export const productCompositionFormFields: Array<ProductCompositionsFormField> = [
  {
    fieldName: 'compositionTitle',
    label: 'Заголовок состава',
    type: 'text',
    validators: [ Validators.required ]
  },
  {
    fieldName: 'comment',
    label: 'Комментарий',
    type: 'textarea'
  }
]
